import React from "react";
import { Alert } from "@material-ui/lab";
import { NavLink } from "react-router-dom";
import PageSpinner from "../../elements/spinner/PageSpinner";
import { useTranslation } from "react-i18next";

import { StyledCol, StyledTable, StyledTableBody, StyledTableHead, StyledTableRow } from "../../styles/styledTable";

const RatesLst = ({ rates }) => {
  const { t } = useTranslation("ratesPage");

  if (!rates) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  if (rates.length === 0) {
    return <Alert severity="warning">{t("rates.table.emptyData")}</Alert>;
  }

  const showDetails = (e) => {
    if (e.target.closest(".stop-event")) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  return (
    <StyledTable
      className="rates-table"
      size="14"
    >
      <StyledTableHead
        className="rates-table__head"
        scroll="auto"
        col="6"
      >
        <div className="rates-table__col rates-table_col-fixed">
          {t("rates.table.currency")}
        </div>
        <div className="rates-table__col">
          {t("rates.table.service")}
        </div>
        <div className="rates-table__col">
          {t("rates.table.selling")}
        </div>
        <div className="rates-table__col">
          {t("rates.table.purchase")}
        </div>
        <div className="rates-table__col">
          {t("rates.table.rateBaseService")}
        </div>
        <div className="rates-table__col">
          {t("rates.table.project")}
        </div>
      </StyledTableHead>
      <StyledTableBody>
        {rates && rates.map((value, key) => (
          <StyledTableRow
            className="rates-table__row"
            key={key}
            scroll="auto"
            col="6"
            onClick={(e) => {showDetails(e);}}
            cursor="pointer"
            as={NavLink}
            to={`/rates/${value.id}`}
          >
            <StyledCol
              data-title={t("rates.table.currency")}
              className="rates-table__col rates-table_col-fixed"
            >
              {value.rateBase.currency.asset}
            </StyledCol>
            <StyledCol
              data-title={t("rates.table.service")}
              className="rates-table__col"
            >
              {value.connection.service.name}
            </StyledCol>
            <StyledCol
              data-title={t("rates.table.selling")}
              className="rates-table__col"
            >
              {value.selling}
            </StyledCol>
            <StyledCol
              data-title={t("rates.table.purchase")}
              className="rates-table__col"
            >
              {value.purchase}
            </StyledCol>
            <StyledCol
              data-title={t("rates.table.rateBaseService")}
              className="rates-table__col"
            >
              {value.rateBase.service.name}
            </StyledCol>
            <StyledCol
              data-title={t("rates.table.project")}
              className="rates-table__col"
            >
              {value.connection.project.name}
            </StyledCol>
          </StyledTableRow>
        ))}
      </StyledTableBody>
    </StyledTable>
  );
};
export default RatesLst;